import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import '@/integration/helpia-people/src/App.css';

const HomeModule = lazy(() => import('./modules/home'));
const AuthModule = lazy(() => import('./modules/auth'));
const UsersModule = lazy(() => import('./modules/users'));
const ConnectionUserModule = lazy(() => import('./modules/connection-user'));
const BlogModule = lazy(() => import('./modules/blog'));
const RolesModule = lazy(() => import('./modules/roles'));
const ProfileModule = lazy(() => import('./modules/profile'));
const SettingsModule = lazy(() => import('./modules/settings'));
const PlansModule = lazy(() => import('./modules/plans'));

// Helpia-people
const PeopleAgentsModule = lazy(() => import('./modules/helpia-people/agents'));
const PeopleProjectsModule = lazy(() => import('./modules/helpia-people/projects'));
const PeopleReportsModule = lazy(() => import('./modules/helpia-people/reports'));
const PeopleBrandsModule = lazy(() => import('./modules/helpia-people/brands'));
const Register = lazy(() => import('@/components/helpia-people/register/Register'));
const DetailTraza = lazy(() => import('@/components/helpia-people/detail-traza/DetailTrasas'));
const ListTrazaV2 = lazy(() => import('@/integration/helpia-people/pages/ListTrazaV2/ListTrazaV2'));

const QuoterModule = lazy(() => import('./modules/quoter'));
const StartingModule = lazy(() => import('./modules/starting'));
const DigitalSignatureModule = lazy(() => import('./modules/digital-signature'));

/* Panel de empresa */
const CompaniesModule = lazy(() => import('./modules/companies'));
const ChannelsModule = lazy(() => import('./modules/channels'));
const CCenterModule = lazy(() => import('./modules/ccenter'));
const ReviewsModule = lazy(() => import('./modules/reviews'));
const SupportsTemplateModule = lazy(() => import('./modules/supports/template'));
// const ClaimsModule = lazy(() => import('./modules/claims'));
const InvoicingModule = lazy(() => import('./modules/invoice'));
const HelpModule = lazy(() => import('./modules/help'));

const LogsModule = lazy(() => import('./modules/logs'));
const FaqsModule = lazy(() => import('./modules/faqs'));
const NotFound = lazy(() => import('./modules/404'));
const Forbidden = lazy(() => import('./modules/403'));
const ResumenEncuestas = lazy(() => import('./modules/reports/ResumenEncuestas'));
const DynamicReport = lazy(() => import('./modules/reports/dynamic-report'));

export { PeopleBrandsModule, PeopleAgentsModule, PeopleProjectsModule };

function App() {
  return (
    <Routes>
      <Route path="*" element={<HomeModule />} />

      {/* <Route path="settings/*" element={<UsersModule />} /> */}
      <Route path="settings/*" element={<SettingsModule />} />
      <Route path="users/*" element={<UsersModule />} />
      <Route path="roles/*" element={<RolesModule />} />
      <Route path="digital-signature/*" element={<DigitalSignatureModule />} />

      <Route path="support-access/*" element={<ConnectionUserModule />} />
      <Route path="support-access/*" element={<ConnectionUserModule />} />

      {/* <Route path="people/agents/*" element={<PeopleAgentsModule />} /> */}
      <Route path="people/agents/*" element={<PeopleAgentsModule />} />
      <Route path="people/brands/*" element={<PeopleBrandsModule />} />
      <Route path="people/projects/*" element={<PeopleProjectsModule />} />
      <Route path="people/reports/*" element={<PeopleReportsModule />} />
      <Route path="helpia-people/register/*" element={<Register />} />
      <Route path="trazas/:id/*" element={<DetailTraza />} />
      <Route path="trazas/*" element={<ListTrazaV2 />} />

      <Route path="companies/*" element={<CompaniesModule />} />
      <Route path="companies/*" element={<CompaniesModule />} />
      <Route path="channels/*" element={<ChannelsModule />} />
      <Route path="ccenter/*" element={<CCenterModule />} />
      <Route path="reviews/*" element={<ReviewsModule />} />
      <Route path="supports/template/*" element={<SupportsTemplateModule />} />
      {/* <Route path="claims/*" element={<ClaimsModule />} /> */}
      <Route path="invoicing/*" element={<InvoicingModule />} />
      <Route path="help/*" element={<HelpModule />} />

      <Route path="starting/*" element={<QuoterModule />} />
      <Route path="starting/*" element={<StartingModule />} />
      <Route path="quoter/*" element={<QuoterModule />} />
      <Route path="plans/*" element={<PlansModule />} />
      <Route path="faqs/*" element={<FaqsModule />} />
      <Route path="posts/*" element={<BlogModule />} />

      <Route path="logs/*" element={<LogsModule />} />
      <Route path="logs/*" element={<LogsModule />} />

      <Route path="resume-reviews/*" element={<ResumenEncuestas />} />
      <Route path="reports/*" element={<DynamicReport />} />

      <Route path="auth/*" element={<AuthModule />} />

      <Route path="profile/*" element={<ProfileModule />} />

      <Route path="403/*" element={<Forbidden />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
